<template>
    <div class="terms-conditions-area">
        <div class="container">
            <div class="terms-conditions-content">
                <h2>Overview</h2>
                <p>Welcome to <strong>Meander Software.</strong> By accessing or using our website, services, or
                    products, you agree to comply with and be bound by the following Terms and Conditions. Please read
                    them carefully.</p>
                <h5>1. Acceptance of Terms</h5>
                <p>By using our website, services, or products, you confirm that you accept these terms and agree to
                    abide by them. If you do not agree, please refrain from using our website or services.</p>

                <h5>2. Services</h5>
                <p>Meander Software provides software development, mobile and web solutions, AI-driven products, and
                    related digital services. We reserve the right to modify, suspend, or discontinue any services at
                    any time without prior notice.</p>

                <h5>3. User Responsibilities</h5>
                <p>When using our website and services, you agree to:</p>
                <ul>
                    <li>Provide accurate, up-to-date information.</li>
                    <li>Use our services for lawful purposes only.</li>
                    <li>Do not engage in activities that could harm our website, systems, or other users.</li>
                    <li>Comply with applicable laws and regulations.</li>


                </ul>
                <h5>4. Intellectual Property</h5>

                <p>All content, software, code, designs, graphics, logos, and trademarks on our website and delivered
                    through our services are the intellectual property of Meander Software or its licensors.</p>
                <ul>
                    <li>You may not copy, modify, distribute, or create derivative works without explicit permission.
                    </li>
                    <li>Any unauthorized use may violate copyright, trademark, and other laws.</li>
                </ul>

                <h5>5. Payment and Fees</h5>
                <p>For paid services or products:</p>
                <ul>
                    <li>Payment terms and amounts will be outlined in proposals, contracts, or invoices.</li>
                    <li>Late payments may incur additional fees or service suspension.</li>
                    <li>All fees are exclusive of taxes unless stated otherwise.</li>
                </ul>

                <h5>6. Limitation of Liability</h5>
                <p>Meander Software is not liable for any indirect, incidental, or consequential damages arising from
                    the use of our website or services.</p>
                <ul>
                    <li>Our maximum liability is limited to the amount paid for the specific service in question.</li>
                    <li>We do not guarantee uninterrupted or error-free service.</li>
                </ul>

                <h5>7. Third-Party Links and Services</h5>
                <p>Our website may contain links to third-party websites or services. We are not responsible for the
                    content, accuracy, or practices of these external sites. Use them at your own risk.</p>

                <h5>8. Termination</h5>
                <p>We reserve the right to suspend or terminate your access to our website or services at any time for
                    violation of these terms, unlawful behavior, or other justifiable reasons.</p>

                <h5>9. Privacy</h5>
                <p>Your use of our website and services is also governed by our <strong>Privacy Policy</strong>, which
                    explains how we collect, use, and protect your personal information.</p>

                <h5>10. Changes to Terms</h5>
                <p>We may update these Terms and Conditions from time to time. Updates will be posted on this page with
                    the revised effective date. Your continued use of our website or services constitutes acceptance of
                    the updated terms.</p>

                <h5>11. Governing Law</h5>
                <p>These Terms and Conditions are governed by the laws of India. Any disputes arising from these terms
                    shall be subject to the exclusive jurisdiction of the courts in that region.</p>

                <h5>12. Contact Us</h5>
                <p>For questions about these Terms and Conditions, please contact us:</p>
                <p>
                  <strong>Email:</strong> <a href="mailto:hi@meander.software">hi@meander.software</a>
                </p>
                <p>
                  <strong>Phone:</strong> <a href="tel:+918090549054">(+91) 80-9054-9054</a>
                </p>

            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'TermsConditions'
}
</script>